export const formatDate = (dateString) => {
    if (!dateString) return '';
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return new Date(dateString).toLocaleDateString('fr-FR', options);
};

export const formatCurrency = (amount, withSymbol = true) => {
    if (amount === null || amount === undefined) {
        return withSymbol ? '0 FCFA' : '0';
    }

    const formattedValue = Number(amount)
        .toLocaleString('fr-FR') // Utilise automatiquement le point comme séparateur de milliers en français
        .replace(/\s/g, '.');    // Remplace les espaces par des points

    return withSymbol ? `${formattedValue} FCFA` : formattedValue;
};



export const getStatusBadge = (status) => {
    switch (status) {
        case 'PAID':
            return <span className="badge bg-success">Payée</span>;
        case 'PENDING':
            return <span className="badge bg-warning text-dark">En attente</span>;
        case 'OVERDUE':
            return <span className="badge bg-danger">En retard</span>;
        default:
            return <span className="badge bg-secondary">Inconnu</span>;
    }
};
